var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload_2",
    d: "M6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0209 4 18.55 4 18V16C4 15.7167 4.09583 15.4792 4.2875 15.2875C4.47917 15.0959 4.71667 15 5 15C5.28333 15 5.52083 15.0959 5.7125 15.2875C5.90417 15.4792 6 15.7167 6 16V18H18V16C18 15.7167 18.0958 15.4792 18.2875 15.2875C18.4792 15.0959 18.7167 15 19 15C19.2833 15 19.5208 15.0959 19.7125 15.2875C19.9042 15.4792 20 15.7167 20 16V18C20 18.55 19.8042 19.0209 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6ZM11 7.85005L9.125 9.72505C8.925 9.92505 8.6875 10.0209 8.4125 10.0125C8.1375 10.0042 7.9 9.90005 7.7 9.70005C7.51667 9.50005 7.42083 9.26672 7.4125 9.00005C7.40417 8.73338 7.5 8.50005 7.7 8.30005L11.3 4.70005C11.4 4.60005 11.5083 4.52922 11.625 4.48755C11.7417 4.44588 11.8667 4.42505 12 4.42505C12.1333 4.42505 12.2583 4.44588 12.375 4.48755C12.4917 4.52922 12.6 4.60005 12.7 4.70005L16.3 8.30005C16.5 8.50005 16.5958 8.73338 16.5875 9.00005C16.5792 9.26672 16.4833 9.50005 16.3 9.70005C16.1 9.90005 15.8625 10.0042 15.5875 10.0125C15.3125 10.0209 15.075 9.92505 14.875 9.72505L13 7.85005V15C13 15.2834 12.9042 15.5209 12.7125 15.7125C12.5208 15.9042 12.2833 16 12 16C11.7167 16 11.4792 15.9042 11.2875 15.7125C11.0958 15.5209 11 15.2834 11 15V7.85005Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file_upload.74783347c9c17be9c7cb34e19e7aa664.svg";
export { ForwardRef as ReactComponent };